// extracted by mini-css-extract-plugin
export default {"landscapesWrapper":"LandscapesPage_landscapesWrapper__j9+Po","landscapesLoaderText":"LandscapesPage_landscapesLoaderText__BuZWO"};